import { getGetAbilitiesKey, getGetTeamKey } from '../../../services/modules/users/users.keys';
import { GetTeamOutput } from '../../../services/modules/users/users.types';
import { GetAbilitiesResponse } from '../../users/ability.types';
import { offlineQueryClient } from '../queryClient/offlineQueryClient';

export const offlineUsersRepository = {
  getUserTeam: (teamId: string) => {
    const team = offlineQueryClient.getQueryData<GetTeamOutput>([teamId, ...getGetTeamKey()]);
    return team;
  },
  getAbilities: (teamId: string) => {
    const abilities = offlineQueryClient.getQueryData<GetAbilitiesResponse>([
      teamId,
      ...getGetAbilitiesKey(),
    ]);
    return abilities;
  },
};
